(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/hooks/use-bank-account.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/hooks/use-bank-account.js');
'use strict';

const {
  displayStatus,
  oauthStatus,
  depositStatus,
  bankIdPollType,
  backendErrorCodes,
  internalConstants
} = svs.accountservicesReact.deposit.constants.swedbankExpress;
const expressService = svs.accountservicesReact.deposit.services.swedbankExpressService;
const logger = svs.accountservicesReact.deposit.swedbankExpress.logger;
const {
  showDepositSuccess,
  showDepositErrorAsync,
  showAuthenticationErrorAsync
} = svs.accountservicesReact.deposit.dialogs.swedbankExpressDialogs;
const {
  getBankIdAppUrl,
  clearUrlParam
} = svs.accountservicesReact.deposit.helpers.swedbankExpressUrlHelper;
const {
  trackDepositOk,
  trackConsentOk,
  trackConsentError,
  trackConsentRetries,
  trackDepositError
} = svs.accountservicesReact.deposit.tracking.swedbankExpressTrack;
const oneWhitePixel = 'data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw==';
const {
  instantPayClear,
  clearFormsDataAction
} = svs.accountservicesReact.deposit.store.deposit.actions;
const {
  removeUrlAfterPayServerAsync
} = svs.accountservicesReact.deposit.helpers.sharedHelpers;
const sessionGetAsync = async () => new Promise(resolve => {
  svs.core.userSession.get('depositamount', (sessionErr, sessionResult) => {
    resolve({
      sessionErr,
      sessionResult
    });
  });
});

const useBankAccount = () => {
  var _svs;
  const [isMobile] = React.useState(svs.core.detect.formfactor.mobile());
  const [isLoading, setIsLoading] = React.useState(true);
  const [isError] = React.useState(false);
  const [applicationDisplayStatus, setApplicationDisplayStatus] = React.useState(false);
  const [cancelDisplayStatus, setCancelDisplayStatus] = React.useState(displayStatus.NEW_CUSTOMER);
  const [accountList, setAccountList] = React.useState([]);
  const [bankList, setBankList] = React.useState([]);
  const [qrCode, setQrCode] = React.useState('');
  const [bankName, setBankName] = React.useState('');
  const [returnUrl, setReturnUrl] = React.useState(((_svs = svs) === null || _svs === void 0 || (_svs = _svs.accountservicesReact) === null || _svs === void 0 || (_svs = _svs.deposit) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 ? void 0 : _svs.returnUrl) || '');
  const [savedAuthorizeId, setSavedAuthorizeId] = React.useState('');
  const doCancelPollRef = React.useRef(false);
  const qrCodeRetries = React.useRef(3); 
  const qrCodeDepositRetries = React.useRef(3); 
  const dispatch = ReactRedux.useDispatch();

  React.useEffect(() => () => {
    if (!isMobile) {
      doCancelPollRef.current = true;
    }
  }, [isMobile]);

  const waitForNewBankIdStatus = async _ref => {
    let {
      authorizeId,
      imageId,
      currentState,
      setQrCode,
      pollType,
      bankSubsidiaryId,
      networkErrorCount = 0
    } = _ref;
    logger.info('hook waitForNewBankIdStatus - isMobile, authorizedId, imageId, currentState, setQrCode, pollType, bankSubsidiaryId: ', isMobile, authorizeId, imageId, currentState, setQrCode, pollType, bankSubsidiaryId, networkErrorCount);
    const resultOfTimeout = () => new Promise(resolve => {
      setTimeout(async () => {
        if (doCancelPollRef.current) {
          logger.debug('*** hook waitForNewBankIdStatus - setTimeout - canceled - doCancelPollRef.current: ', doCancelPollRef.current);
          return {
            status: displayStatus.CANCEL
          };
        } else if (document.visibilityState === 'hidden') {
          logger.debug('*** hook waitForNewBankIdStatus tab inactive');
          resolve(await resultOfTimeout());
        }
        let result = {};
        switch (pollType) {
          case bankIdPollType.POLL_CONSENT:
          case bankIdPollType.POLL_CHANGE_BANK:
            result = await expressService.postPollAuthNewBankStatusAsync({
              authorizeId
            });
            break;
          case bankIdPollType.POLL_CONSENT_SELECT_BANK:
            result = await expressService.postPollAuthNewBankStatusAsync({
              authorizeId,
              bankSubsidiaryId
            });
            break;
          case bankIdPollType.POLL_DEPOSIT:
            result = await expressService.postPollDepositStatusAsync({
              paymentId: authorizeId
            });
            break;
          default:
            return {
              status: 'error',
              error: "pollType is not known: ".concat(pollType)
            };
        }
        if (result.status === displayStatus.ERROR && result.errorCode === backendErrorCodes.JUPITER_NETWORK_ERROR) {
          logger.warn('*** hook waitForNewBankIdStatus - jupiter potential network error: ', result);
          if (networkErrorCount < internalConstants.MAX_NETWORK_RETRIES) {
            logger.info('*** hook waitForNewBankIdStatus - jupiter potential network error - try one more time');
            networkErrorCount = networkErrorCount + 1;
            result.status = displayStatus.SUCCESS;
            result.statusEnum = currentState;
          }
        }
        if (result.status !== displayStatus.SUCCESS || result.statusEnum !== currentState) {
          logger.debug('*** hook waitForNewBankIdStatus - resolve result: ', result);
          resolve(result);
        } else {
          logger.debug('*** hook waitForNewBankIdStatus - one more time: ', result);
          if (!isMobile && (currentState === oauthStatus.oauth2sts_RECEIVED || currentState === oauthStatus.oauth2sts_IN_PROGRESS || currentState === depositStatus.withdsts_RECEIVED || currentState === depositStatus.withdsts_IN_PROGRESS)) {
            logger.info('hook waitForNewBankIdStatus - Not mobile - set new qr-image');
            try {
              const qr = await expressService.getQRImageAsync({
                imageId
              });
              if (qr.image) {
                setQrCode(qr.image);
              }
            } catch (error) {
              return {
                status: displayStatus.ERROR,
                statusEnum: backendErrorCodes.NO_MORE_QR_IMAGE,
                errorCode: 1
              };
            }
          }
          const res2 = await waitForNewBankIdStatus({
            authorizeId,
            imageId,
            currentState,
            setQrCode,
            pollType,
            bankSubsidiaryId,
            networkErrorCount
          });
          logger.debug('*** hook waitForNewBankIdStatus - back from one more time, resolve result2: ', res2);
          resolve(res2);
        }
      }, 1000);
    });
    const resp = await resultOfTimeout();
    logger.debug('*** hook waitForNewBankIdStatus - end of function, resp: ', resp);
    return resp;
  };
  const doClearBackend = () => {
    doCancelPollRef.current = true;
    setApplicationDisplayStatus(cancelDisplayStatus);
  };

  const getBankList = async function () {
    let {
      isNewConsentSelectBank = false
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    try {
      const {
        status,
        bankSubsidiaries,
        errorCode
      } = await expressService.getBankListAsync();
      logger.debug('*** hook getBankList - status, bankSubsidiaries, errorCode: ', status, bankSubsidiaries, errorCode);
      setBankList(bankSubsidiaries);
      if (isNewConsentSelectBank) {
        setApplicationDisplayStatus(displayStatus.CONSENT_SELECT_BANK);
      } else {
        setApplicationDisplayStatus(displayStatus.CHANGE_BANK);
        setCancelDisplayStatus(displayStatus.CHANGE_BANK);
      }
    } catch (error) {
      logger.error('hook getBankList - Error in Try-Catch: ', error);
    }
  };

  const getBankAccounts = async () => {
    const {
      status,
      bankAccounts,
      bankName,
      errorCode
    } = await expressService.getBankAccountsAsync();
    switch (status) {
      case displayStatus.SUCCESS:
        {
          setAccountList(bankAccounts);
          const bname = bankName && bankName.length > 2 ? bankName : 'Swedbank';
          setBankName(bname);
          setApplicationDisplayStatus(displayStatus.SUCCESS);
          setCancelDisplayStatus(displayStatus.SUCCESS);
        }
        break;
      case displayStatus.ERROR:
        logger.warn('hook getBankAccounts - Got ERROR: ', errorCode);
        switch (errorCode) {
          case backendErrorCodes.MISSING_TOKEN:
            setApplicationDisplayStatus(displayStatus.NEW_CUSTOMER);
            setCancelDisplayStatus(displayStatus.NEW_CUSTOMER);
            break;
          case backendErrorCodes.EXPIRED_REFRESH_TOKEN:
            setApplicationDisplayStatus(displayStatus.EXPIRED_TOKEN);
            setCancelDisplayStatus(displayStatus.EXPIRED_TOKEN);
            break;
          case backendErrorCodes.CUSTOMER_HAS_MULTIPLE_BANKS:
            setApplicationDisplayStatus(displayStatus.CHANGE_BANK);
            setCancelDisplayStatus(displayStatus.CHANGE_BANK);
            break;
          case backendErrorCodes.CUSTOMER_CONTACT_BANK_KYC:
            showAuthenticationErrorAsync(backendErrorCodes.CUSTOMER_CONTACT_BANK_KYC);
            setApplicationDisplayStatus(cancelDisplayStatus);
            break;
          default:
            showAuthenticationErrorAsync(backendErrorCodes.GENERAL_ERROR);
            setApplicationDisplayStatus(cancelDisplayStatus);
            break;
        }
        break;
      default:
        break;
    }
    setIsLoading(false);
    qrCodeRetries.current = 3;
  };

  const doConsentInitAndPoll = async function () {
    var _returnNewPollStatus7, _returnNewPollStatus8, _returnNewPollStatus9, _returnNewPollStatus10, _returnNewPollStatus12, _returnNewPollStatus13, _returnNewPollStatus18;
    let {
      bankSubsidiaryId = '',
      isConsentSelectBank,
      urlAuthorizeId = ''
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    logger.debug('*** hook doConsentInitAndPoll - bankSubsidiaryId, urlAuthorizeId: ', bankSubsidiaryId, urlAuthorizeId);
    try {
      var _returnNewPollStatus, _returnNewPollStatus2, _returnNewPollStatus3, _returnNewPollStatus4, _returnNewPollStatus14, _returnNewPollStatus15, _returnNewPollStatus16, _returnNewPollStatus17;
      clearUrlParam('aid');
      clearUrlParam('pid');
      doCancelPollRef.current = false;
      setIsLoading(false);
      let status = 0;
      let errorCode = 0;
      let authorizeId = urlAuthorizeId;
      let imageId = '';
      let returnNewPollStatus;
      if (urlAuthorizeId === '' && !isConsentSelectBank) {
        const reply = await expressService.postInitiateNewConsentAsync({
          isMobile,
          bankSubsidiaryId
        });
        status = reply === null || reply === void 0 ? void 0 : reply.status;
        errorCode = reply === null || reply === void 0 ? void 0 : reply.errorCode;
        authorizeId = reply === null || reply === void 0 ? void 0 : reply.authorizeId;
        const autoStartToken = reply === null || reply === void 0 ? void 0 : reply.autoStartToken;
        imageId = reply === null || reply === void 0 ? void 0 : reply.imageId;
        logger.debug('*** hook doConsentInitAndPoll - postInitiateNewConsentAsync - status, errorCode, authorizeId, autostartToken, imageId: ', status, errorCode, authorizeId, autoStartToken, imageId);
        if (errorCode && errorCode > 0) {
          if (errorCode === 408 || errorCode === 666) {
            logger.info('hook doConsentInitAndPoll - Got network ERROR: ', errorCode);
          } else {
            logger.warn('hook doConsentInitAndPoll - Got ERROR: ', errorCode);
          }
          showAuthenticationErrorAsync(errorCode);
          return {
            status: 'error'
          };
        }
        if (!authorizeId || authorizeId.length < 2) {
          logger.warn('hook doConsentInitAndPoll - did not get any authorizeId. ERROR!');
          return {
            status: 'error'
          };
        }
        if (isMobile && autoStartToken && autoStartToken.length > 2) {
          setApplicationDisplayStatus(displayStatus.BANKID_AUTH_APP);
          const bankIdAppUrl = getBankIdAppUrl({
            autoStartToken,
            authorizeId,
            returnUrl
          });
          logger.info('hook doConsentInitAndPoll - Mobile - navigate to bankIdAppUrl: ', bankIdAppUrl);
          svs.utils.url.navigate(bankIdAppUrl);
        } else {
          logger.info('hook doConsentInitAndPoll - Not mobile - set new qr-image');
          const resp = await expressService.getQRImageAsync({
            imageId
          });
          setQrCode(resp === null || resp === void 0 ? void 0 : resp.image);
          setApplicationDisplayStatus(displayStatus.BANKID_AUTH_QRCODE);
        }

        returnNewPollStatus = await waitForNewBankIdStatus({
          authorizeId,
          imageId,
          currentState: oauthStatus.oauth2sts_RECEIVED,
          setQrCode,
          pollType: bankIdPollType.POLL_CONSENT
        });
        logger.info('hook doConsentInitAndPoll - waitForNewBankIdStatus - isConsentSelectBank=false - after poll with oauth2sts_RECEIVED=4, and not coming back from BankId: ', returnNewPollStatus);
      } else if (isConsentSelectBank) {
        setApplicationDisplayStatus(isMobile ? displayStatus.CONSENT_SELECT_BANK_WAIT_APP : displayStatus.CONSENT_SELECT_BANK_WAIT);
        authorizeId = savedAuthorizeId;
        returnNewPollStatus = await waitForNewBankIdStatus({
          authorizeId,
          imageId,
          currentState: oauthStatus.oauth2sts_RECEIVED,
          setQrCode,
          pollType: bankIdPollType.POLL_CONSENT_SELECT_BANK,
          bankSubsidiaryId
        });
        logger.info('hook doConsentInitAndPoll - waitForNewBankIdStatus - isConsentSelectBank=true - after poll with oauth2sts_RECEIVED=4, and customer has several banks: ', returnNewPollStatus);
      } else {
        logger.info('hook doConsentInitAndPoll - Returning from BankId');
        setApplicationDisplayStatus(isMobile ? displayStatus.BANKID_AUTH_WAIT_APP : displayStatus.BANKID_AUTH_WAIT);
        returnNewPollStatus = {};
        returnNewPollStatus.statusEnum = oauthStatus.oauth2sts_IN_PROGRESS;
      }

      if (((_returnNewPollStatus = returnNewPollStatus) === null || _returnNewPollStatus === void 0 ? void 0 : _returnNewPollStatus.statusEnum) === oauthStatus.oauth2sts_IN_PROGRESS) {
        if (isMobile) {
          setApplicationDisplayStatus(isConsentSelectBank ? displayStatus.CONSENT_SELECT_BANK_WAIT_APP : displayStatus.BANKID_AUTH_WAIT_APP);
        } else {
          setApplicationDisplayStatus(isConsentSelectBank ? displayStatus.CONSENT_SELECT_BANK_WAIT : displayStatus.BANKID_AUTH_WAIT);
        }
        returnNewPollStatus = await waitForNewBankIdStatus({
          authorizeId,
          imageId,
          currentState: oauthStatus.oauth2sts_IN_PROGRESS,
          setQrCode,
          pollType: bankIdPollType.POLL_CONSENT
        });
        logger.info('hook doConsentInitAndPoll - waitForNewBankIdStatus - after poll with oauth2sts_IN_PROGRESS=5: ', returnNewPollStatus);
      }
      if (((_returnNewPollStatus2 = returnNewPollStatus) === null || _returnNewPollStatus2 === void 0 ? void 0 : _returnNewPollStatus2.statusEnum) === oauthStatus.oauth2sts_NEED_BANK_SUBSIDARY) {
        logger.info('hook doConsentInitAndPoll - we are done with BankId, but customer have mutiple banks');
        setSavedAuthorizeId(authorizeId);
        await getBankList({
          isNewConsentSelectBank: true
        });
        return;
      }
      if (((_returnNewPollStatus3 = returnNewPollStatus) === null || _returnNewPollStatus3 === void 0 ? void 0 : _returnNewPollStatus3.statusEnum) === oauthStatus.oauth2sts_FINAL_COMPLETED) {
        logger.info('hook doConsentInitAndPoll - we are done with BankId, getting bankAccounts');
        trackConsentOk();
        clearUrlParam('pid');
        await getBankAccounts();
        return;
      }

      if (((_returnNewPollStatus4 = returnNewPollStatus) === null || _returnNewPollStatus4 === void 0 ? void 0 : _returnNewPollStatus4.status) === displayStatus.SUCCESS) {
        var _returnNewPollStatus5, _returnNewPollStatus6;
        logger.info('hook doConsentInitAndPoll - we have polling success, but not with good result. statusEnum: ', (_returnNewPollStatus5 = returnNewPollStatus) === null || _returnNewPollStatus5 === void 0 ? void 0 : _returnNewPollStatus5.statusEnum);
        switch ((_returnNewPollStatus6 = returnNewPollStatus) === null || _returnNewPollStatus6 === void 0 ? void 0 : _returnNewPollStatus6.statusEnum) {
          case oauthStatus.oauth2sts_UNKNOWN_INTERNAL_ISSUE:
          case oauthStatus.oauth2sts_INVALID_NOT_AUTH:
            trackConsentError((_returnNewPollStatus7 = returnNewPollStatus) === null || _returnNewPollStatus7 === void 0 ? void 0 : _returnNewPollStatus7.statusEnum);
            showAuthenticationErrorAsync(backendErrorCodes.GENERAL_ERROR);
            setApplicationDisplayStatus(displayStatus.NEW_CUSTOMER);
            setCancelDisplayStatus(displayStatus.NEW_CUSTOMER);
            break;
          case oauthStatus.oauth2sts_NOT_CUSTOMER_IN_SELECTED_BANK:
            trackConsentError((_returnNewPollStatus8 = returnNewPollStatus) === null || _returnNewPollStatus8 === void 0 ? void 0 : _returnNewPollStatus8.statusEnum);
            showAuthenticationErrorAsync(backendErrorCodes.NOT_A_CUSTOMER_IN_SWD_SUBSIDIARY);
            await getBankList({
              isNewConsentSelectBank: false
            });
            break;
          case oauthStatus.oauth2sts_NOT_CUSTOMER_IN_SWEDBANK_GROUP:
            trackConsentError((_returnNewPollStatus9 = returnNewPollStatus) === null || _returnNewPollStatus9 === void 0 ? void 0 : _returnNewPollStatus9.statusEnum);
            setApplicationDisplayStatus(displayStatus.NEW_CUSTOMER);
            showAuthenticationErrorAsync(backendErrorCodes.NOT_A_CUSTOMER_IN_SWD_GROUP);
            await getBankAccounts();
            break;
          case oauthStatus.oauth2sts_CUSTOMER_CONTACT_SWEDBANK:
            trackConsentError((_returnNewPollStatus10 = returnNewPollStatus) === null || _returnNewPollStatus10 === void 0 ? void 0 : _returnNewPollStatus10.statusEnum);
            showAuthenticationErrorAsync(backendErrorCodes.USER_CONTACT_SWEDBANK);
            setApplicationDisplayStatus(displayStatus.NEW_CUSTOMER);
            await getBankAccounts();
            break;
          case oauthStatus.oauth2sts_FINAL_FAILED_UNSPECIFIED_REASON:
            logger.info('hook doConsentInitAndPoll - we have timeout for scanning qr code, error: ', oauthStatus.oauth2sts_FINAL_FAILED_UNSPECIFIED_REASON);
            setQrCode(oneWhitePixel);
            if (!isMobile && qrCodeRetries.current > 0) {
              var _returnNewPollStatus11;
              logger.debug("Generating new QR-code, retries left ".concat(qrCodeRetries.current));
              qrCodeRetries.current = qrCodeRetries.current - 1;
              trackConsentRetries((_returnNewPollStatus11 = returnNewPollStatus) === null || _returnNewPollStatus11 === void 0 ? void 0 : _returnNewPollStatus11.statusEnum);
              await doConsentInitAndPoll({
                bankSubsidiaryId
              });
              return;
            }
            trackConsentError((_returnNewPollStatus12 = returnNewPollStatus) === null || _returnNewPollStatus12 === void 0 ? void 0 : _returnNewPollStatus12.statusEnum);
            showAuthenticationErrorAsync(oauthStatus.oauth2sts_FINAL_FAILED_UNSPECIFIED_REASON);
            setApplicationDisplayStatus(displayStatus.NEW_CUSTOMER);
            await getBankAccounts();
            return;
          default:
            trackConsentError((_returnNewPollStatus13 = returnNewPollStatus) === null || _returnNewPollStatus13 === void 0 ? void 0 : _returnNewPollStatus13.statusEnum);
            showAuthenticationErrorAsync(backendErrorCodes.GENERAL_ERROR);
            setApplicationDisplayStatus(displayStatus.NEW_CUSTOMER);
            await getBankAccounts();
            break;
        }
        return;
      }
      if (((_returnNewPollStatus14 = returnNewPollStatus) === null || _returnNewPollStatus14 === void 0 ? void 0 : _returnNewPollStatus14.status) === displayStatus.CANCEL) {
        return;
      }
      logger.warn('hook doConsentInitAndPoll - Error or Canceled: ', (_returnNewPollStatus15 = returnNewPollStatus) === null || _returnNewPollStatus15 === void 0 ? void 0 : _returnNewPollStatus15.errorCode);
      trackConsentError((_returnNewPollStatus16 = returnNewPollStatus) === null || _returnNewPollStatus16 === void 0 ? void 0 : _returnNewPollStatus16.errorCode);
      switch ((_returnNewPollStatus17 = returnNewPollStatus) === null || _returnNewPollStatus17 === void 0 ? void 0 : _returnNewPollStatus17.errorCode) {
        case backendErrorCodes.GENERAL_ERROR:
        case backendErrorCodes.TRY_AGAIN:
        case backendErrorCodes.NO_MORE_QR_IMAGE:
          showAuthenticationErrorAsync(backendErrorCodes.GENERAL_ERROR);
          setApplicationDisplayStatus(cancelDisplayStatus);
          break;
        case backendErrorCodes.NOT_A_CUSTOMER_IN_SWD_SUBSIDIARY:
          showAuthenticationErrorAsync(backendErrorCodes.NOT_A_CUSTOMER_IN_SWD_SUBSIDIARY);
          await getBankList({
            isNewConsentSelectBank: false
          });
          break;
        case backendErrorCodes.NOT_A_CUSTOMER_IN_SWD_GROUP:
          setApplicationDisplayStatus(displayStatus.NEW_CUSTOMER);
          showAuthenticationErrorAsync(backendErrorCodes.NOT_A_CUSTOMER_IN_SWD_GROUP);
          await getBankAccounts();
          break;
        case backendErrorCodes.USER_CONTACT_SWEDBANK:
          setApplicationDisplayStatus(displayStatus.NEW_CUSTOMER);
          showAuthenticationErrorAsync(backendErrorCodes.USER_CONTACT_SWEDBANK);
          await getBankAccounts();
          break;
        case backendErrorCodes.BANKID_CANCELED:
          break;
        case backendErrorCodes.JUPITER_NETWORK_ERROR:
          logger.warn('hook doConsentInitAndPoll - jupiter potentially network error: ', (_returnNewPollStatus18 = returnNewPollStatus) === null || _returnNewPollStatus18 === void 0 ? void 0 : _returnNewPollStatus18.errorCode);
          await getBankAccounts();
          break;
        default:
          showAuthenticationErrorAsync(backendErrorCodes.GENERAL_ERROR);
          setApplicationDisplayStatus(cancelDisplayStatus);
          break;
      }
    } catch (error) {
      logger.error('hook doConsentInitAndPoll - Error in Try-Catch: ', error);
      trackConsentError(backendErrorCodes.GENERAL_ERROR);
      showAuthenticationErrorAsync(backendErrorCodes.GENERAL_ERROR);
      await getBankAccounts();
    }
  };

  const doDepositInitAndPoll = async _ref2 => {
    var _returnNewPollStatus28, _returnNewPollStatus32;
    let {
      accountNumber = '',
      amount = 0,
      urlPaymentId = ''
    } = _ref2;
    logger.info('hook doDepositInitAndPoll - amount, paymentId: ', amount, urlPaymentId);
    try {
      var _returnNewPollStatus19, _returnNewPollStatus20, _returnNewPollStatus21, _returnNewPollStatus22, _returnNewPollStatus24, _returnNewPollStatus29, _returnNewPollStatus30, _returnNewPollStatus31;
      clearUrlParam('aid');
      clearUrlParam('pid');
      doCancelPollRef.current = false;
      setIsLoading(false);
      let status = 0;
      let errorCode = 0;
      let paymentId = urlPaymentId;
      let imageId = '';
      let returnNewPollStatus;
      if (urlPaymentId === '') {
        svs.core.userSession.set('depositamount', amount);
        const replay = await expressService.postInitiateDepositAsync({
          isMobile,
          accountNumber,
          amount
        });
        status = replay === null || replay === void 0 ? void 0 : replay.status;
        errorCode = replay === null || replay === void 0 ? void 0 : replay.errorCode;
        paymentId = replay === null || replay === void 0 ? void 0 : replay.paymentId;
        const autoStartToken = replay === null || replay === void 0 ? void 0 : replay.autoStartToken;
        imageId = replay === null || replay === void 0 ? void 0 : replay.imageId;
        logger.info('hook doDepositInitAndPoll - from postInitiateDepositAsync. status, errorCode, paymentId, autoStartToken, imageId: ', status, errorCode, paymentId, autoStartToken, imageId);
        if (errorCode && errorCode > 0) {
          logger.warn('hook doDepositInitAndPoll - Got ERROR: ', errorCode);
          if (errorCode === backendErrorCodes.DEPOSIT_SUSPENDED) {
            location.reload();
            setApplicationDisplayStatus(displayStatus.LOADER);
          } else {
            showDepositErrorAsync(errorCode);
          }
          return {
            status: 'error'
          };
        }
        if (!paymentId || paymentId.length < 2) {
          logger.warn('hook doDepositInitAndPoll - did not get any paymentId. ERROR!');
          return {
            status: 'error'
          };
        }

        if (isMobile && autoStartToken && autoStartToken.length > 2) {
          setApplicationDisplayStatus(displayStatus.BANKID_AUTH_APP);
          const bankIdAppUrl = getBankIdAppUrl({
            autoStartToken,
            paymentId,
            returnUrl
          });
          logger.info('hook doDepositInitAndPoll - Mobile - navigate to bankIdAppUrl: ', bankIdAppUrl);
          svs.utils.url.navigate(bankIdAppUrl);
        } else {
          logger.info('hook doDepositInitAndPoll - Not mobile - set new qr-image');
          const resp = await expressService.getQRImageAsync({
            imageId
          });
          setQrCode(resp === null || resp === void 0 ? void 0 : resp.image);
          setApplicationDisplayStatus(displayStatus.BANKID_DEBIT_QRCODE);
        }

        returnNewPollStatus = await waitForNewBankIdStatus({
          authorizeId: paymentId,
          imageId,
          currentState: depositStatus.withdsts_RECEIVED,
          setQrCode,
          pollType: bankIdPollType.POLL_DEPOSIT
        });
        logger.info('hook doDepositInitAndPoll - waitForNewBankIdStatus - after poll with withdsts_RECEIVED=4, and not coming back from BankId: ', returnNewPollStatus);
      } else {
        logger.info('hook doDepositInitAndPoll - Returning from BankId');
        setApplicationDisplayStatus(isMobile ? displayStatus.BANKID_AUTH_WAIT_APP : displayStatus.BANKID_AUTH_WAIT);
        returnNewPollStatus = {};
        returnNewPollStatus.statusEnum = depositStatus.withdsts_IN_PROGRESS;
      }

      if (((_returnNewPollStatus19 = returnNewPollStatus) === null || _returnNewPollStatus19 === void 0 ? void 0 : _returnNewPollStatus19.statusEnum) === depositStatus.withdsts_IN_PROGRESS) {
        setApplicationDisplayStatus(isMobile ? displayStatus.BANKID_DEBIT_WAIT_APP : displayStatus.BANKID_DEBIT_WAIT);
        returnNewPollStatus = await waitForNewBankIdStatus({
          authorizeId: paymentId,
          imageId,
          currentState: depositStatus.withdsts_IN_PROGRESS,
          setQrCode,
          pollType: bankIdPollType.POLL_DEPOSIT
        });
        logger.info('hook doDepositInitAndPoll - waitForNewBankIdStatus - after poll with withdsts_IN_PROGRESS=5: ', returnNewPollStatus);
      }
      if (((_returnNewPollStatus20 = returnNewPollStatus) === null || _returnNewPollStatus20 === void 0 ? void 0 : _returnNewPollStatus20.statusEnum) === depositStatus.withdsts_IN_PROGRESS_AUTHENICATED) {
        returnNewPollStatus = await waitForNewBankIdStatus({
          authorizeId: paymentId,
          imageId,
          currentState: depositStatus.withdsts_IN_PROGRESS_AUTHENICATED,
          setQrCode,
          pollType: bankIdPollType.POLL_DEPOSIT
        });
        logger.info('hook doDepositInitAndPoll - waitForNewBankIdStatus - after poll with withdsts_IN_PROGRESS_AUTHENICATED=6: ', returnNewPollStatus);
      }
      if (((_returnNewPollStatus21 = returnNewPollStatus) === null || _returnNewPollStatus21 === void 0 ? void 0 : _returnNewPollStatus21.status) === displayStatus.CANCEL) {
        return;
      }
      if (((_returnNewPollStatus22 = returnNewPollStatus) === null || _returnNewPollStatus22 === void 0 ? void 0 : _returnNewPollStatus22.statusEnum) === depositStatus.withdsts_FINAL_COMPLETE) {
        var _returnNewPollStatus23;
        logger.info('hook doDepositInitAndPoll - we are done with BankId, deposit');
        const accountBalance = (_returnNewPollStatus23 = returnNewPollStatus) === null || _returnNewPollStatus23 === void 0 ? void 0 : _returnNewPollStatus23.accountBalance;
        svs.components.account_balance.set(accountBalance);
        const {
          sessionErr,
          sessionResult
        } = await sessionGetAsync();
        trackDepositOk(sessionErr, sessionResult);

        dispatch(instantPayClear());
        dispatch(clearFormsDataAction());

        if ((returnUrl === null || returnUrl === void 0 ? void 0 : returnUrl.length) > 0) {
          logger.info('hook doDepositInitAndPoll - show deposit done dialog and then navigate to returnUrl: ', returnUrl);
          await removeUrlAfterPayServerAsync();
          await showDepositSuccess({
            amount: sessionResult,
            accountBalance
          }, returnUrl);
        } else {
          logger.info('hook doDepositInitAndPoll - show deposit done dialog. No returnUrl');
          clearUrlParam('pid');
          await showDepositSuccess({
            amount: sessionResult,
            accountBalance
          }, returnUrl);
          await getBankAccounts();
        }
        return;
      }

      if (((_returnNewPollStatus24 = returnNewPollStatus) === null || _returnNewPollStatus24 === void 0 ? void 0 : _returnNewPollStatus24.status) === displayStatus.SUCCESS) {
        var _returnNewPollStatus25, _returnNewPollStatus26, _returnNewPollStatus27;
        logger.info('hook doDepositInitAndPoll - we have polling success, but not with good result. statusEnum: ', (_returnNewPollStatus25 = returnNewPollStatus) === null || _returnNewPollStatus25 === void 0 ? void 0 : _returnNewPollStatus25.statusEnum);
        trackDepositError((_returnNewPollStatus26 = returnNewPollStatus) === null || _returnNewPollStatus26 === void 0 ? void 0 : _returnNewPollStatus26.statusEnum);
        switch ((_returnNewPollStatus27 = returnNewPollStatus) === null || _returnNewPollStatus27 === void 0 ? void 0 : _returnNewPollStatus27.statusEnum) {
          case depositStatus.withdsts_FINAL_CANCEL_TIMEOUT_SHORT:
            logger.info('hook doDepositInitAndPoll - we have timeout for scanning qr code, error: ', (_returnNewPollStatus28 = returnNewPollStatus) === null || _returnNewPollStatus28 === void 0 ? void 0 : _returnNewPollStatus28.statusEnum);
            setQrCode(oneWhitePixel);
            if (!isMobile && qrCodeDepositRetries.current > 0) {
              logger.debug("Generating new QR-code, retries left ".concat(qrCodeDepositRetries.current));
              qrCodeDepositRetries.current = qrCodeDepositRetries.current - 1;
              await doDepositInitAndPoll({
                accountNumber,
                amount,
                urlPaymentId
              });
              return;
            }
          case depositStatus.withdsts_UNKNOWN_INTERNAL_ISSUE:
          case depositStatus.withdsts_FINAL_ERROR:
          case depositStatus.withdsts_FINAL_CANCEL_UNKNOWN_REASON:
          case depositStatus.withdsts_FINAL_CANCEL_TIMEOUT_LONG:
            showAuthenticationErrorAsync(backendErrorCodes.GENERAL_ERROR);
            break;
          case depositStatus.withdsts_FINAL_CANCEL_USER_INTERRUPT:
            showDepositErrorAsync(backendErrorCodes.GENERAL_ERROR);
            break;
          case depositStatus.withdsts_FINAL_REJECTED:
            showDepositErrorAsync(backendErrorCodes.INSUFFICIENT_FUND);
            break;
          default:
            showAuthenticationErrorAsync(backendErrorCodes.GENERAL_ERROR);
            break;
        }
        qrCodeDepositRetries.current = 3;
        await getBankAccounts();
        return;
      }
      logger.warn('hook doDepositInitAndPoll - Error or Canceled: ', (_returnNewPollStatus29 = returnNewPollStatus) === null || _returnNewPollStatus29 === void 0 ? void 0 : _returnNewPollStatus29.errorCode);
      trackDepositError((_returnNewPollStatus30 = returnNewPollStatus) === null || _returnNewPollStatus30 === void 0 ? void 0 : _returnNewPollStatus30.errorCode);
      switch ((_returnNewPollStatus31 = returnNewPollStatus) === null || _returnNewPollStatus31 === void 0 ? void 0 : _returnNewPollStatus31.errorCode) {
        case backendErrorCodes.GENERAL_ERROR:
        case backendErrorCodes.TRY_AGAIN:
        case backendErrorCodes.NO_MORE_QR_IMAGE:
          showDepositErrorAsync(backendErrorCodes.GENERAL_ERROR);
          break;
        case backendErrorCodes.JUPITER_NETWORK_ERROR:
          logger.warn('hook doDepositInitAndPoll - jupiter potentially network error: ', (_returnNewPollStatus32 = returnNewPollStatus) === null || _returnNewPollStatus32 === void 0 ? void 0 : _returnNewPollStatus32.errorCode);
          break;
        default:
          showDepositErrorAsync(backendErrorCodes.GENERAL_ERROR);
          break;
      }
      await getBankAccounts();
    } catch (error) {
      logger.error('hook doDepositInitAndPoll - Error in Try-Catch: ', error);
      trackDepositError(backendErrorCodes.GENERAL_ERROR);
      showDepositErrorAsync(backendErrorCodes.GENERAL_ERROR);
      await getBankAccounts();
    }
  };
  return {
    isLoading,
    isError,
    applicationDisplayStatus,
    accountList,
    bankName,
    bankList,
    qrCode,
    getBankAccounts,
    doConsentInitAndPoll,
    doDepositInitAndPoll,
    getBankList,
    doClearBackend,
    setReturnUrl
  };
};
svs.accountservicesReact.deposit.swedbankExpress.hooks.useBankAccount = useBankAccount;

 })(window);